import React, { FC, useEffect, useRef, useState } from "react";
import Editor, { createEditorStateWithText } from '@draft-js-plugins/editor';
import createToolbarPlugin from '@draft-js-plugins/static-toolbar';
// import {
//   ItalicButton,
//   BoldButton,
//   UnderlineButton,
//   UnorderedListButton,  
// } from '@draft-js-plugins/buttons';
import createImagePlugin from '@draft-js-plugins/image';
// import createLinkifyPlugin from '@draft-js-plugins/linkify';
import './textEditor.scss';
import 'draft-js/dist/Draft.css';
import '@draft-js-plugins/static-toolbar/lib/plugin.css';

import IconBold from "@assets/icon_Text_Type.svg";
import IconItalic from "@assets/icon_italic_Type.svg";
import IconUnderscore from "@assets/icon_Text_Underscore.svg";
import IconLink from "@assets/icon_link.svg";
import IconPaperClip from "@assets/icon_paperclip.svg";
import IconImage from "@assets/icon_image.svg";

const staticToolbarPlugin = createToolbarPlugin();
const staticImagePlugin = createImagePlugin();
// const { Toolbar } = staticToolbarPlugin;
const plugins = [staticToolbarPlugin, staticImagePlugin ];
type TEditorProps = {
  changeHandler?: any;
  content?: any;
  actionsMenu?:any;
  autoFocus?:any;
};

const TextEditor: FC<TEditorProps> = ({content, changeHandler, actionsMenu, autoFocus}: TEditorProps) => {
  const [editorState, setEditorState] = useState(createEditorStateWithText(content || ""));

  const onChange = (data: any) => {
    setEditorState(data);
  };

  useEffect(()=>{
    console.log("TextEditor.useEffect");
    changeHandler(editorState?.getCurrentContent()?.getBlocksAsArray()?.reduce((acc, val)=> acc.concat(val.getText()), ""))
  }, [changeHandler, editorState]);

  const ref = useRef(null);
  useEffect(()=>{
    console.log("TextEditor.useEffect");
    const _ref: any = ref
    if( autoFocus  ) {
      _ref.current.focus();
    }
  }, [autoFocus])
  return (
    <div className="textEditor custom-scroll-bar">
        <Editor
            editorState={editorState}
            ref={ref}
            onChange={onChange}
            plugins={plugins}
            placeholder={actionsMenu ? "The toolbar above the editor can be used for formatting text, as in conventional static editors  … " : "Enter Some Text"}
        />
        {/* <Toolbar> */}
            {/* {// may be use React.Fragment instead of div to improve perfomance after React 16
            externalProps => (
              actionsMenu && <div>
                <BoldButton {...externalProps} />
                <ItalicButton {...externalProps} />
                <UnderlineButton {...externalProps} />
                <UnorderedListButton {...externalProps} />
              </div>
            )} */}
            {actionsMenu && <div className="editor-icon">
              <span><img src={IconBold} alt="bold-icon" /></span>
              <span><img src={IconItalic} alt="italic-icon" /></span>
              <span><img src={IconUnderscore} alt="underscore-icon" /></span>
              <span className="pipe"></span>
              <span><img src={IconLink} alt="link-icon" /></span>
              <span><img src={IconPaperClip} alt="papar-clip-icon" /></span>
              <span className="pipe"></span>
              <span><img src={IconImage} alt="upload-pic-icon" /></span>
              </div>}
          {/* </Toolbar> */}
    </div>
  );
};

export default TextEditor;